import { Section, Cell, List, Button } from "@telegram-apps/telegram-ui";
import { useNavigate } from "react-router-dom";
import { usePageBack } from "../lib/telegram.js";

export default function NotFound() {
  const navigate = useNavigate();
  usePageBack("/");
  return (
    <List>
      <Section>
        <Cell multiline subtitle="Возможно, ссылка устарела или раздел ещё в работе.">
          <div style={{ fontSize: 36, marginBottom: 6 }}>🪂</div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>Страница не найдена</div>
        </Cell>
        <Cell>
          <Button stretched mode="filled" onClick={() => navigate("/")}>На главную</Button>
        </Cell>
      </Section>
    </List>
  );
}
